module.exports = "<div class=\"container\" ui-view>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/admin/admin.html
// module id = 49
// module chunks = 0